import pwcLogo from "assets/images/companyLogos/pwc-logo.svg";
import vismaLogo from "assets/images/companyLogos/visma-logo.png";
import pwcLogoWhite from "assets/images/companyLogos/PWC-Logo-white.png";
import vismaLogoWhite from "assets/images/companyLogos/visma-logo-white.png";

interface Partners {
  name: string;
  description: string;
  url: string;
  logo: string;
  whiteLogo: string;
}

// Record containing Bindeleddet NTNU's company partners.
// Follow pattern under if you are adding or changing partners.

export const partners: Record<string, Partners> = {
  PwC: {
    name: "PwC",
    description:
      "PwC er verdens største nettverk av rådgivere, revisorer og advokater. Vi leverer et bredt spekter av profesjonelle tjenester og er en av landets ledende leverandører innen rådgivning og revisjon. I Norge har vi nært 1500 ansatte, representert i et landsdekkende kontornettverk. Tjenestene som leveres fra rådgivningsenheten til PwC i Norge omfatter prosessforbedring, strategisk analyse, verdikjedeoptimalisering, IT-strategi og systemvalg, prosjekt- og endringsledelse, i tillegg til transaksjonsstøtte, M&A, verdsettinger og finansiell rådgivning.",
    url: "https://www.pwc.com/",
    logo: pwcLogo,
    whiteLogo: pwcLogoWhite,
  },
  Visma: {
    name: "Visma",
    description:
      "Visma er et av Nordens største IT-konsern og ledende leverandør av cloud basert business software og tjenester til et bredt spekter av kundegrupper innen privat og offentlig sektor. Våre IT-løsninger bidrar til å gjøre våre 600 000 kunder mer effektive og til enhver tid ett skritt foran sine konkurrenter. I tillegg benytter ytterligere 330 000 kunder oss som hostingpartner. Vi har hovedkontor i Oslo og over 5500 ansatte fordelt i 15 land. Visma har gjort over 100 oppkjøp og hadde i 2016 en omsetning på NOK 7 855 mill.",
    url: "https://www.visma.no/",
    logo: vismaLogo,
    whiteLogo: vismaLogoWhite,
  },
};
